import React from 'react';

const ContactSection = () => {
  return (
    <>
      <style jsx>{`
        .contact-section-10 {
          background: linear-gradient(135deg, rgba(33, 150, 243, 0.5) 0%, rgba(25, 118, 210, 0.5) 100%), 
                      url('/images/forum.png') center/cover no-repeat;
          min-height: 500px;
          display: flex;
          align-items: center;
          padding: 80px 40px;
          position: relative;
          overflow: hidden;
        }

        .contact-section-10::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          opacity: 0.3;
          animation: contactPatternMove 20s linear infinite;
        }

        @keyframes contactPatternMove {
          0% { transform: translate(0, 0); }
          100% { transform: translate(100px, 100px); }
        }

        .contact-container-10 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 80px;
          position: relative;
          z-index: 2;
        }

        .contact-card-10 {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 0;
          padding: 0;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          backdrop-filter: blur(10px);
          overflow: hidden;
          max-width: 400px;
          width: 100%;
          animation: contactSlideInLeft 0.8s ease-out;
        }

        .contact-header-10 {
          background: #1a237e;
          padding: 25px 30px;
          color: white;
        }

        .contact-title-10 {
          font-size: 2.2rem;
          color: white;
          font-weight: 300;
          margin: 0;
          font-family: 'Arial', sans-serif;
          letter-spacing: 1px;
        }

        .contact-content-10 {
          padding: 30px;
          background: white;
        }

        .contact-section-10-item {
          margin-bottom: 25px;
          border-bottom: 2px solid #2196F3;
          padding-bottom: 20px;
        }

        .contact-section-10-item:last-child {
          margin-bottom: 0;
          border-bottom: none;
          padding-bottom: 0;
        }

        .contact-section-10-title {
          font-size: 1.2rem;
          font-weight: bold;
          color: #333;
          margin: 0 0 12px 0;
          font-family: 'Arial', sans-serif;
        }

        .contact-info {
          color: #666;
          font-size: 1rem;
          line-height: 1.6;
          font-family: 'Arial', sans-serif;
          margin: 0;
        }

        .phone-numbers {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .phone-number {
          color: #666;
          text-decoration: none;
          font-size: 1rem;
          font-family: 'Arial', sans-serif;
          transition: color 0.3s ease;
        }

        .phone-number:hover {
          color: #2196F3;
        }

        .phone-number:focus {
          outline: 2px solid #2196F3;
          outline-offset: 2px;
        }

        .email-link {
          color: #666;
          text-decoration: none;
          font-size: 1rem;
          font-family: 'Arial', sans-serif;
          transition: color 0.3s ease;
          display: block;
          margin-bottom: 6px;
        }

        .email-link:hover {
          color: #2196F3;
        }

        .email-link:focus {
          outline: 2px solid #2196F3;
          outline-offset: 2px;
        }

        .social-icons {
          display: flex;
          gap: 15px;
          margin-top: 5px;
        }

        .social-icon-10 {
          width: 40px;
          height: 40px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
        }

        .social-icon-10 img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .social-icon-10:hover {
          background: #555;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
        }

        .social-icon-10:focus {
          outline: 2px solid #2196F3;
          outline-offset: 2px;
        }

        .branding-section {
          flex: 1;
          display: flex;
          flex-grow: 1;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
          animation: contactSlideInRight 0.8s ease-out 0.3s both;
        }

        .main-logo {
          margin-bottom: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          animation: contactLogoFloat 4s ease-in-out infinite;
        }

        .main-logo img {
          max-width: 100%;
          height: auto;
          display: block;
        }

        @keyframes contactLogoFloat {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }

        .logo-icon {
          font-size: 4rem;
          margin-bottom: 20px;
          display: block;
        }

        .brand-name {
          font-size: 4rem;
          font-weight: bold;
          margin: 0 0 10px 0;
          font-family: 'Arial', sans-serif;
          text-shadow: 2px 2px 8px rgba(0,0,0,0.3);
          letter-spacing: 2px;
        }

        .brand-subtitle {
          font-size: 1.2rem;
          opacity: 0.9;
          margin: 0 0 50px 0;
          font-family: 'Arial', sans-serif;
          letter-spacing: 1px;
          font-weight: 300;
        }

        .partnership-section {
          display: flex;
          align-items: center;
          gap: 30px;
          background: rgba(255, 255, 255, 0.1);
          padding: 30px 40px;
          border-radius: 20px;
          backdrop-filter: blur(10px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
          margin-top: 30px;
        }

        .shell-logo {
          width: 80px;
          height: 80px;
          background: #FFD700;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          color: #FF0000;
          font-weight: bold;
          box-shadow: 0 10px 30px rgba(255, 215, 0, 0.4);
          animation: contactShellPulse 3s ease-in-out infinite;
          overflow: hidden;
        }

        .shell-logo img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        @keyframes contactShellPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        .partnership-text {
          color: white;
          font-family: 'Arial', sans-serif;
          font-weight: bold;
          font-size: 1.6rem;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
          line-height: 1.3;
        }

        @keyframes contactSlideInLeft {
          from {
            opacity: 0;
            transform: translateX(-100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes contactSlideInRight {
          from {
            opacity: 0;
            transform: translateX(100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @media (max-width: 1024px) {
          .contact-container-10 {
            flex-direction: column;
            gap: 50px;
            text-align: center;
          }

          .contact-card-10 {
            max-width: 600px;
          }

          .brand-name {
            font-size: 3.5rem;
          }

          .partnership-section {
            flex-direction: column;
            gap: 20px;
            text-align: center;
          }
        }

        @media (max-width: 768px) {
          .contact-section-10 {
            padding: 60px 20px;
          }

          .contact-header-10 {
            padding: 25px 30px;
          }

          .contact-title-10 {
            font-size: 2rem;
          }

          .contact-content-10 {
            padding: 30px;
          }

          .brand-name {
            font-size: 2.8rem;
          }

          .brand-subtitle {
            font-size: 1rem;
          }

          .partnership-text {
            font-size: 1.4rem;
          }

          .shell-logo {
            width: 60px;
            height: 60px;
            font-size: 1.5rem;
          }

          .social-icons {
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .contact-section-10 {
            padding: 40px 15px;
          }

          .contact-title-10 {
            font-size: 1.8rem;
          }

          .contact-content-10 {
            padding: 25px;
          }

          .contact-section-10-title {
            font-size: 1.2rem;
          }

          .contact-info,
          .phone-number,
          .email-link {
            font-size: 1rem;
          }

          .brand-name {
            font-size: 2.2rem;
          }

          .logo-icon {
            font-size: 3rem;
          }

          .partnership-section {
            padding: 25px 30px;
          }

          .partnership-text {
            font-size: 1.2rem;
          }

          .main-logo img {
            max-width: 80%;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="contact-section-10"
        role="region"
        aria-labelledby="contact-heading"
        itemScope
        itemType="https://schema.org/ContactPage"
      >
        <div className="contact-container-10">
          <div className="contact-card-10" itemScope itemType="https://schema.org/Organization">
            <div className="contact-header-10">
              <h2 id="contact-heading" className="contact-title-10" itemProp="name">
                Contact
              </h2>
            </div>
            
            <div className="contact-content-10">
              <div className="contact-section-10-item" itemScope itemType="https://schema.org/ContactPoint">
                <h3 className="contact-section-10-title">Phone / Whatsapp</h3>
                <div className="phone-numbers">
                  <a 
                    href="tel:+212702094593" 
                    className="phone-number"
                    itemProp="telephone"
                    aria-label="Appeler le 07 02 09 45 93"
                  >
                    07 02 09 45 93
                  </a>
                  <a 
                    href="tel:+212608112626" 
                    className="phone-number"
                    itemProp="telephone"
                    aria-label="Appeler le 06 08 11 26 26"
                  >
                    06 08 11 26 26
                  </a>
                  <a 
                    href="tel:+212522027256" 
                    className="phone-number"
                    itemProp="telephone"
                    aria-label="Appeler le 05 22 02 72 56"
                  >
                    05 22 02 72 56
                  </a>
                </div>
              </div>

              <div className="contact-section-10-item">
                <h3 className="contact-section-10-title">Email</h3>
                <div>
                  <a 
                    href="mailto:responsable-developpement@faucon-bleu.ma" 
                    className="email-link"
                    itemProp="email"
                    aria-label="Envoyer un email au responsable développement"
                  >
                    responsable-developpement@faucon-bleu.ma
                  </a>
                  <a 
                    href="mailto:contact@faucon-bleu.ma" 
                    className="email-link"
                    itemProp="email"
                    aria-label="Envoyer un email de contact général"
                  >
                    contact@faucon-bleu.ma
                  </a>
                </div>
              </div>

              <div className="contact-section-10-item">
                <h3 className="contact-section-10-title">Social</h3>
                <div className="social-icons" role="list">
                  <a 
                    href="https://instagram.com/fauconbleu" 
                    className="social-icon-10"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Suivre Faucon Bleu sur Instagram"
                    role="listitem"
                  >
                    <img src='/images/instagram.webp' alt="Instagram" loading="lazy" />
                  </a>
                  <a 
                    href="https://linkedin.com/company/fauconbleu" 
                    className="social-icon-10"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Suivre Faucon Bleu sur LinkedIn"
                    role="listitem"
                  >
                    <img src='/images/linkedin.webp' alt="LinkedIn" loading="lazy" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="branding-section">
            <div className="main-logo">
              <img 
                src='/images/logo-header.png' 
                alt="Logo Faucon Bleu - Centre de services automobiles"
                height={150} 
                width="70%" 
                loading="lazy"
                itemProp="logo"
              />
            </div>

            <div className="partnership-section">
              <div className="shell-logo">
                <img 
                  src='/images/shell.png' 
                  alt="Shell - Partenaire officiel Faucon Bleu"
                  loading="lazy"
                />
              </div>
              <div className="partnership-text">
                PARTENAIRE<br />
                OFFICIEL
              </div>
            </div>
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ContactPage",
              "mainEntity": {
                "@type": "AutoRepair",
                "name": "Faucon Bleu",
                "description": "Centre de services automobiles à Casablanca",
                "url": "https://fauconbleu.ma",
                "logo": "https://fauconbleu.ma/images/logo-header.png",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Casablanca",
                  "addressCountry": "MA"
                },
                "contactPoint": [
                  {
                    "@type": "ContactPoint",
                    "telephone": "+212702094593",
                    "contactType": "Customer Service",
                    "availableLanguage": ["French", "Arabic"],
                    "contactOption": "TollFree"
                  },
                  {
                    "@type": "ContactPoint",
                    "telephone": "+212608112626",
                    "contactType": "Customer Service",
                    "availableLanguage": ["French", "Arabic"]
                  },
                  {
                    "@type": "ContactPoint",
                    "telephone": "+212522027256",
                    "contactType": "Customer Service",
                    "availableLanguage": ["French", "Arabic"]
                  }
                ],
                "email": [
                  "responsable-developpement@faucon-bleu.ma",
                  "contact@faucon-bleu.ma"
                ],
                "sameAs": [
                  "https://instagram.com/fauconbleu",
                  "https://linkedin.com/company/fauconbleu"
                ]
              }
            })
          }}
        />
      </section>
    </>
  );
};

export default ContactSection;